(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pantera-main-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pantera-category-trigger]').forEach((trigger) => {
      if (trigger.dataset.panteraCategoryDrawerReady === 'true') return;

      const drawerId = trigger.getAttribute('aria-controls');
      const drawer = drawerId ? document.getElementById(drawerId) : null;

      if (!drawer) return;

      trigger.dataset.panteraCategoryDrawerReady = 'true';

      const syncExpandedState = () => {
        trigger.setAttribute('aria-expanded', drawer.hasAttribute('open') ? 'true' : 'false');
      };

      drawer.addEventListener('theme-drawer:open', syncExpandedState);
      drawer.addEventListener('theme-drawer:close', syncExpandedState);
      syncExpandedState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pantera-mega-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pantera-header]').forEach((header) => {
      if (header.dataset.menuReady === 'true') return;
      header.dataset.menuReady = 'true';

      const toggle = header.querySelector('[data-pantera-menu-toggle]');
      const menu = header.querySelector('[data-pantera-menu]');
      if (!toggle || !menu) return;

      const closeMenu = () => {
        menu.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      };

      toggle.addEventListener('click', () => {
        const willOpen = !menu.classList.contains('is-open');
        menu.classList.toggle('is-open', willOpen);
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });

      menu.addEventListener('click', (event) => {
        if (event.target.closest('a')) closeMenu();
      });

      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) closeMenu();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.classList.contains('is-open')) {
          closeMenu();
          toggle.focus();
        }
      });

      window.matchMedia('(min-width: 991px)').addEventListener('change', closeMenu);
    });
  })();

  (() => {
    document.querySelectorAll('[data-pantera-header]').forEach((header) => {
      const section = header.parentElement;
      if (!section || section.dataset.stickyReady === 'true') return;
      section.dataset.stickyReady = 'true';

      const utility = section.previousElementSibling?.querySelector('.pantera-utility');
      const pageWrapper = document.querySelector('.page-wrapper');
      const getScrollTop = () => Math.max(window.scrollY || 0, pageWrapper?.scrollTop || 0);

      const syncStickyState = () => {
        const threshold = utility?.offsetHeight || 0;
        section.classList.toggle('pantera-header-sticky', getScrollTop() >= threshold);
      };

      pageWrapper?.addEventListener('scroll', syncStickyState, { passive: true });
      window.addEventListener('scroll', syncStickyState, { passive: true });
      window.addEventListener('resize', syncStickyState);

      if (window.ResizeObserver) {
        const observer = new ResizeObserver(syncStickyState);
        observer.observe(header);
        if (utility) observer.observe(utility);
      }

      syncStickyState();
    });
  })();

  (() => {
    const initializeCartTrigger = () => {
      const triggers = document.querySelectorAll('[data-pantera-cart-trigger][aria-controls="cart-drawer"]');
      const drawer = document.getElementById('cart-drawer');
      if (!drawer || !triggers.length) return;

      const syncTrigger = () => {
        triggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', drawer.hasAttribute('open') ? 'true' : 'false');
        });
      };

      document.addEventListener('theme-drawer:open', (event) => {
        if (event.target?.id === 'cart-drawer') syncTrigger();
      });

      document.addEventListener('theme-drawer:close', (event) => {
        if (event.target?.id === 'cart-drawer') syncTrigger();
      });

      syncTrigger();
    };

    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', initializeCartTrigger, { once: true });
    } else {
      initializeCartTrigger();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pantera-product-detail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pantera-features]').forEach((featureSection) => {
      if (featureSection.dataset.panteraFeaturesReady === 'true') return;

      const productDetail = featureSection.closest('.pantera-product-detail');
      const description = productDetail?.querySelector('[data-pantera-description]');
      const featureList = featureSection.querySelector('[data-pantera-feature-list]');
      const sourceLists = Array.from(description?.querySelectorAll('ul, ol') || []);
      const sourceList =
        sourceLists.find((list) => /caracter/i.test(list.previousElementSibling?.textContent || '')) || sourceLists[0];

      if (!description || !featureList || !sourceList) return;

      const sourceHeading = sourceList.previousElementSibling;
      if (sourceHeading && /^(H2|H3|H4)$/.test(sourceHeading.tagName) && /caracter/i.test(sourceHeading.textContent || '')) {
        sourceHeading.remove();
      }

      const featureItems = Array.from(sourceList.children).filter((item) => item.matches('li'));
      if (featureItems.length === 0) return;

      sourceList.classList.add('pantera-product-detail__feature-list-items');
      featureList.append(sourceList);
      featureSection.hidden = false;
      featureSection.dataset.panteraFeaturesReady = 'true';

      const toggle = featureSection.querySelector('[data-pantera-features-toggle]');
      if (!toggle || featureItems.length <= 6) return;

      const label = toggle.querySelector('[data-pantera-features-toggle-label]');
      const icon = toggle.querySelector('.pantera-product-detail__features-toggle-icon');
      let expanded = false;

      const syncToggle = () => {
        sourceList.classList.toggle('is-expanded', expanded);
        toggle.setAttribute('aria-expanded', String(expanded));
        if (label) label.textContent = expanded ? 'Ver menos características' : 'Ver más características';
        if (icon) icon.textContent = expanded ? '⌃' : '⌄';
      };

      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        expanded = !expanded;
        syncToggle();
      });
      syncToggle();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
